import { useEffect } from 'react';
import propertyService from '../../service/property.service';
import DynamicPropertyTable from './DynamicPropertyTable';
import useParam from '../../context/ParamContext';

const DynamicPropertyMain = ({
  submenuId,
  disabled,
  selectedValues,
  canEdit,
  setDefaultValues,
  dynProperties,
  groupState = {},
  dynLoadingState,
}) => {
  const { params } = useParam();
  const { dynProps, setDynProps } = dynProperties;
  const { setDynLoading } = dynLoadingState;

  useEffect(() => {
    if (submenuId > 0) {
      getFormProperties();
    }
  }, [submenuId]);

  const getFormProperties = () => {
    propertyService
      .getPropertiesByFormId(submenuId)
      .then((data) => {
        if (!canEdit && Boolean(params.EXCLUDE_DYN_PROP_BY_PROPERTYID)) {
          const teszt = data.filter(
            (filtered) => filtered.property.id !== parseInt(params.EXCLUDE_DYN_PROP_BY_PROPERTYID)
          );
          setDynProps(teszt);
        } else {
          setDynProps(data);
        }
      })
      .finally(() => {
        setDynLoading(false);
      });
  };

  return (
    <>
      {dynProps.length > 0 && (
        <DynamicPropertyTable
          rows={dynProps}
          disabled={disabled}
          selectedValues={selectedValues}
          setDefaultValues={setDefaultValues}
          groupState={groupState}
        />
      )}
    </>
  );
};

export default DynamicPropertyMain;
